import GET_ARTICLES from "../class/getArticles";
import LazyDisp from "../class/lazydisp";

const [w, d] = [window, document];

const domReady = TPL => false;

const jqInit = () => false;

const onLoadHtml = () => {
  const works_block = new GET_ARTICLES('.block-works__list[data-plugin="getArticles"]');
  works_block.maketag = (tags) => tags.map(tag => `<span class="tag">${tag}</span>`).join('');
  works_block.makeItem = (item,content) => `
  <li class="block-works-item">
    <a href="${item.href}" class="block-works-item__link">
      <figure class="block-works-item__thumb">
        <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy" class="block-works-item__thumb-img">
      </figure>
      <div class="block-works-item__body">
        <h5 class="title">${item.title}</h5>
        ${item.keywords? '<div class="tags">'+ works_block.maketag(item.keywords) + '</div>': ''}
      </div>
      <!-- /.block-works-item__body -->
    </a>
    <!-- /.block-works-item__link -->
  </li>`;
  // works_block.makeItem = (item) => console.log(item);
  works_block.render();

  // LazyDisp開始
  new LazyDisp('[data-lazydisp]');
}

export default function SERVICE () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => jqInit());
  $(() => Promise.all([w.load['loadHtml']]).then( onLoadHtml ) );
}